import React from 'react';
import { Mail, MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface EmailModeToggleProps {
  isEmailMode: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

export function EmailModeToggle({ isEmailMode, onToggle, disabled = false }: EmailModeToggleProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant={isEmailMode ? "default" : "ghost"}
            size="icon"
            onClick={onToggle}
            disabled={disabled}
            className="h-8 w-8 rounded-lg"
          >
            {isEmailMode ? (
              <Mail className="h-4 w-4" />
            ) : (
              <MessageCircle className="h-4 w-4" />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{isEmailMode ? 'Switch to chat mode' : 'Switch to email mode'}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}